export const LINK = 'LINK_COMPONENT';
export const POP_UP = 'POPUP_COMPONENT';
export const LINK_POP_UP = 'LINK_POPUP_COMPONENT';
export const CO_BROWSE = 'CO_BROWSE_COMPONENT';
export const SLIDE_IN = 'SLIDER_COMPONENT';
export const RIGHT = 'RIGHT';
